import script from "./agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./agreement.vue?vue&type=script&setup=true&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=0bab5f1c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bab5f1c"]])

export default __exports__